'use client';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import './breadCrumb.scss';
import Link from 'next/link';

type BreadcrumbItem = {
  label: string;
  href: string;
  active?: boolean;
};
type BreadcrumbProps = {
  items: BreadcrumbItem[];
};
const BreadcrumbComponent = ({ items }: BreadcrumbProps) => {
  return (
    <Breadcrumb aria-label="breadcrumb">
      {items.map((item, index) => (
        <li
          key={index}
          className={`breadcrumb-item ${item.active ? 'active' : ''}`}
          aria-current={item.active ? 'page' : undefined}
        >
          {item.active ? (
            item.label
          ) : (
            <Link href={item.href}>{item.label}</Link>
          )}
        </li>
      ))}
    </Breadcrumb>
  );
};
export default BreadcrumbComponent;
